import { defineStore } from 'pinia'
import { useBootstrapStore } from "./bootstrap";
export const useAppStateStore = defineStore({
  id: 'appState',
  state: () => {
    return {
      loading: false,
      toast: null,
      currentPage:"home",
      sendingOrder:false
    }
  },
  actions: {
    async useToast({ text, color, icon, timeout = 3000 }: any) {
      this.closeToast()

      let toastData = {
        isShow: true,
        text,
        color: color || this.toast.color,
        icon: icon || this.toast.icon,
        timeout: timeout || this.toast.timeout
      }
      this.toast = toastData

      if (this.toast.clearTime != null) {
        clearTimeout(this.toast.clearTime)
      }
      this.toast.clearTime = setTimeout(() => {
        this.toast.isShow = false
      }, timeout)
    },

    back() {
      const _guestBack = {
        "/add": "/",
        "/summary": "/",
      };

      const path = useRouter().currentRoute.value.path;
      if (_guestBack[path]) {
        useRouter().push(_guestBack[path]);
      }
    },

    setCurrentPage(page:string){
      this.currentPage = page
    },
    closeToast() {
      if (this.toast) {
        clearTimeout(this.toast.clearTime)
        this.toast.isShow = false
      }
    },
  },
  getters: {}
})
